import { mmun_texts } from "../language/mmun";
import { en_texts } from "../language/en";
import { mand_texts } from "../language/mand";
import { Storage } from '@capacitor/storage';

var lang_selected : string = "";

export const enum LANGUAGE {
	TXT_HELLO = 0,
	TXT_TEST,
	TXT_OK,
	TXT_CANCEL,
	TXT_CLOSE,
	TXT_ENGLISH_LANGUAGE,
	TXT_MMUN_LANGUAGE,
	TXT_MANDRIAN_LANGUAGE,
	TXT_KAYIN_LANGUAGE,
	TXT_YAKHINE_LANGUAGE,
	TXT_CHIN_LANGUAGE,
	TXT_SHAN_LANGUAGE,
	TXT_KACHIN_LANGUAGE,
	TXT_SERVER_ERROR,
	TXT_HOME_TAB,
	TXT_EXPLORE_TAB,
	TXT_NOTI_TAB,
	TXT_LIVE_TAB,
	TXT_MSG_TAB,
	TXT_STUDIO_TAB,
	TXT_SETTING_TAB,
	TXT_ERROR_CLOSE,
	TXT_ERROR_CAP,
	TXT_DELETE,
	TXT_SLIDE_LEFT_DEL,
	TXT_GOOGLE_LOGIN,
	TXT_SIGNIN_WITH_APPLE,
	TXT_LOGIN_WITH_EMAIL,
	TXT_EMAIL,
	TXT_PASSWORD,
	TXT_FORGET_PASSWORD,
	TXT_DO_LOGIN,
	TXT_DO_REGISTER,
	TXT_ASK_LOGOUT,
	TXT_EMAIL_DOT,
	TXT_USERNAME_EDIT,
	TXT_PROFILEPIC_UPLOAD,
	TXT_LANGUAGE_EDIT,
	TXT_LOGOUT,
	TXT_PLZ_WAIT,
	TXT_ADD_CONTENT_CAP,
	TXT_CHOOSE_CONTENT,
	TXT_UPLOAD_VIDEO_CAP,
	TXT_VIDEO_NEXT,
	TXT_VIDEO_HOW,
	TXT_VIDEO_CODE,
	TXT_VIDEO_TITLE,
	TXT_VIDEO_DESC,
	TXT_VIDEO_CATEGORY,
	TXT_VIDEO_TAG,
	TXT_VIDEO_UPLOAD,
	TXT_VIDEO_CODE_EMPTY,
	TXT_VIDEO_TITLE_EMPTY,
	TXT_VIDEO_ASK_CHANGE,
	TXT_VIDEO_ASK_CHANGE_CAP,
	TXT_NC_CAP,
	TXT_NC_NAME,
	TXT_NC_DESC,
	TXT_NC_CATEGORY,
	TXT_NC_CREATE,
	TXT_NC_ABOUT,
	TXT_NC_EDIT_CAP,
	TXT_NC_SAVE,
	TXT_YOUR_CHANNEL,
	TXT_CHANNEL_LIST,
	TXT_YOUR_VIDEOS,
	TXT_CH_DESCRIP,
	TXT_CH_EDIT,
	TXT_CH_DELETE,
	TXT_CH_DELETE_ASK,
	TXT_CH_UPLOAD_AVATAR,
	TXT_CH_EDIT_BUT,
	TXT_CH_EDIT_ALL_BUT,
	TXT_VIDEO_CODE_INVALID,
	TXT_CHANNEL,
	TXT_UPLOAD_SUCCESS,
	TXT_CH_NO_VIDEO,
	TXT_CH_ADD_NO_VIDEO,
	TXT_CHAT_TYPE,
	TXT_CHAT_EMAIL_INPUT,
	TXT_CHAT_UPLOAD_IMG,
	TXT_CHAT_SEND_MONEY,
	TXT_CHAT_LOADMORE,
	TXT_CHAT_DELETE,
	TXT_CHAT_BLOCK,
	TXT_BLOCK_LIST,
	TXT_DELETE_CHAT_TITLE,
	TXT_DELETE_CHAT_DESC,
	TXT_BLOCK_CHAT_TITLE,
	TXT_BLOCK_CHAT_DESC,
	TXT_OFFLINE,
	TXT_INFO_HELP_CAP,
	TXT_INFO_HELP_DESC,
	TXT_INFO_NOTI_CAP,
	TXT_INFO_NOTI_DESC,
	TXT_INFO_BLOCK_CAP,
	TXT_INFO_BLOCK_DESC,
	TXT_BLOCKLIST_CAP,
	TXT_UNBLOCK_CAP,
	TXT_UNBLOCK_LBL,
	TXT_CANT_SEND_MSG,
	TXT_SEND_DATE,
	TXT_NEED_MORE_TIME,
	TXT_CHAT_MSG_TAB,
	TXT_CHAT_SHOP_TAB,
	TXT_CHAT_REQ_TAB,
	TXT_CHAT_SEARCH,
	TXT_INFO_CHAT_CAP,
	TXT_INFO_CHAT_DESC,
	TXT_NEW_CONTENT,
	TXT_CREATE_CONTENT_CAP,
	TXT_CONTENT_VIDEO,
	TXT_CONTENT_IMAGE,
	TXT_CONTENT_POST,
	TXT_CONTENT_META,
	TXT_USD_CAP,
	TXT_NTOKEN_CAP,
	TXT_BUY_TOKENS,
	TXT_NWALLET_INSTALL_CAP,
	TXT_NWALLET_INSTALL_DESC,
	TXT_NWALLET_INSTALL,
	TXT_NWALLET_OPEN_CAP,
	TXT_NWALLET_OPEN_DESC,
	TXT_NWALLET_OPEN,
	TXT_MINT_GAME_CAP,
	TXT_MINT_GAME_DESC,
	TXT_MINT_GAME,
	TXT_GAMES_ALL,
	TXT_GAMES_HIGHLIGHT,
	TXT_GAMES_NEW,
	TXT_GAMES,
	TXT_GAMES_DIRECT_DL,
	TXT_GAMES_IOS,
	TXT_GAMES_PLAYSTORE,
	TXT_GAMES_LOWER_PHONES,
	TXT_WALLET_CAP,
	TXT_COMMENT_CAP,
	TXT_FIRSTLIKE_CAP,
	TXT_FIRSTLIKE_DESC,
	TXT_FIRSTLIKE_CLOSE,
	TXT_GET_NTOKEN_BUT,
	TXT_SUPER_LIKE_CAP,
	TXT_SUPER_LIKE_DESC,
	TXT_NO_NTOKEN_LIKE,
	TXT_NO_LIKE_POST,
	TXT_TYPE_COMMENT,
	TXT_NO_COMMENT_POST,
	TXT_NO_WALLET_MSG,
	TXT_NTOKEN_EXCHANGE_RATE,
	TXT_NTK_EXCHANGE_CAP,
	TXT_NTK_EXCHANGE_BUT,
	TXT_DEL,
	TXT_NOT_ENOUGH_NTK,
	TXT_AVAIL_USD,
	TXT_NTK_EX_EXCHANGE,
	TXT_NTK_EX_XRATE,
	TXT_NTK_EX_RECEIVE,
	TXT_USD_LEFT,
	TXT_NTK_EX_DO,
	TXT_NTK_CONFIRM_CAP,
	TXT_CLEAR,
	TXT_SUBMIT_PASSKEY,
	TXT_ENTER_PASSKEY,
	TXT_NTK_SUCCESS_USD,
	TXT_NTK_SUCCESS_NTK,
	TXT_NTK_SUCCESS_BACK,
	TXT_NTK_SUCCESS_CAP,
	TXT_VIEW,
	TXT_EXCHANGE_RATE_CAP,
	TXT_USD_NTK_EXCHANGE_RATE,
	TXT_UPDATED_TIME,
	TXT_USD_NTK_EXCHANGE,
	TXT_SEARCH,
	TXT_USER_MESSAGE,
	TXT_USER_FOLLOW,
	TXT_USER_UNFOLLOW,
	TXT_USER_FRIEND,
	TXT_USER_FOLLOWER,
	TXT_SHARE_POST,
	TXT_REPORT_ADMIN,
	TXT_BLOCK_USER,
	TXT_PROFILE_FOLLOWER,
	TXT_PROFILE_EDIT,
	TXT_FOLLOW_THIS_USER,
	TXT_FOLLOW_USER,
	TXT_UNFOLLOW_USER,
	TXT_DELETE_POST,
	TXT_ASK_DEL_POST_CAP,
	TXT_ASK_DEL_POST_DESC,
	TXT_LOGOUT_TITLE,
	TXT_FOLLOWERS,
	TXT_REPORT_ADMIN_DETAIL,
	TXT_REPORT_CAP,
	TXT_REPORT_SUCCESS,
	TXT_NOTI_CAP,
	TXT_NOTI_UNREAD,
	TXT_NOTI_SEE_ALL,
	TXT_SUPPORTERS,
	TXT_CONTENT_404_CAP,
	TXT_CONTENT_404_DESC,
	TXT_FORGET_PASSWORD_TITLE,
	TXT_FORGET_PASSWORD_DESC,
	TXT_SEND_RESET_MAIL,
	TXT_REGISTER_TITLE,
	TXT_INVALID_EMAIL_FORMAT,
	TXT_PSW_NOT_8CHAR,
	TXT_CONFIRM_PASSWORD,
	TXT_CONFIRM_PSW_MATCH,
	TXT_REFERRAL_EMAIL,
	TXT_REGISTER2,
	TXT_EMAIL_INFO,
	TXT_REFERRAL_ID_OPT,
	TXT_CONFIRM_EMAIL_CAP,
	TXT_CONFIRM_EMAIL_DESC,
	TXT_CONFIRM_EMAIL_BUT,
	TXT_RESEND_EMAIL,
	TXT_EMAIL_CONFIRM_SUS,
	TXT_RESEND_EMAIL_MSG,
	TXT_CHANGE_NAME_TITLE,
	TXT_CHANHE_NAME_LBL,
	TXT_CHANGE_NAME_DO,
	TXT_LANG_TITLE,
	TXT_CHANGE_LANG,
	TXT_ENGLISH_LBL,
	TXT_MANDARIN_LBL,
	TXT_MYANMAR_LBL,
	TXT_POST,
	TXT_CONTENT_ADD_CAP,
	TXT_CONTENT_ADD_PIC,
	TXT_CONTENT_ADD_VIDEO_FILE,
	TXT_CONTENT_ADD_VIDEO,
	TXT_CONTENT_ADD_QUESTION,
	TXT_CONTENT_ADD_TITLE,
	TXT_CONTENT_ADD_HIDE,
	TXT_PASTE_VIDEO_CODE,
	TXT_ARTICLE_TITLE,
	TXT_WHATS_ON_MIND,
	TXT_NO_MORE_CONTENT,
	TXT_LIKE_TO_UNLOCK,
	TXT_SUPERLIKE_TO_UNLOCK,
	TXT_LIKE_TO_UNLOCK_POST,
	TXT_SUPERLIKE_TO_UNLOCK_POST,
	TXT_MAIN_NO_CONTENT,
	TXT_MAIN_NO_CONTENT_BUT,
	TXT_FOLLOWER_LIST,
	TXT_GALLERY_LIST,
	TXT_CAT_POPULAR,
	TXT_CAT_NEWS,
	TXT_CAT_TRENDING,
	TXT_CAT_LATEST,
	TXT_CAT_NSFW,
	TXT_EXPLORE_NO_CONTENT,
	TXT_COMMENT_LIKES,
	TXT_COPY_TEXT,
	TXT_DEL_COMMENT,
	TXT_ASK_DEL_COMMENT,
	TXT_ASK_DEL_COMMENT_DESC,
	TXT_TAB_FRIENDS,
	TXT_TAB_FOLLOWED,
	TXT_TAB_FOLLOWERS,
	TXT_CAP_NO_FRIEND,
	TXT_DESC_NO_FRIEND,
	TXT_CAP_NO_FOLLOWED,
	TXT_DESC_NO_FOLLOWED,
	TXT_CAP_NO_FOLLOWER,
	TXT_DESC_NO_FOLLOWER,
	TXT_COMMENT_REPLY,
	TXT_CMT_LIKE_ALL,
	TXT_CMT_LIKE_LIKE,
	TXT_CMT_LIKE_DISLIKE,
	TXT_CMT_REPLYING_TO,
	TXT_SHARE_MY_PROFILE,
	TXT_UPDATE_CAP,
	TXT_UPDATE_INFO,
	TXT_APK_DOWNLOAD,
	TXT_APP_DOWNLOAD,
	TXT_DIRECT_DOWNLOAD,
	TXT_MAN_TITLE_1,
	TXT_MAN_TITLE_2,
	TXT_MAN_REFRESH,
	TXT_CHECK_NSFW,
	TXT_COM_REACT_1,
	TXT_COM_REACT_2,
	TXT_ANONYMOUS_POST,
	TXT_ANONYMOUS_COMMENT,
	TXT_CHAT_SEND_GIF,
	TXT_MAX_CONTENT_SIZE_1,
	TXT_MAX_CONTENT_SIZE_2,
	TXT_LIVE_CHAT,
	TXT_PUBLIC_CHAT_TAG,
	TXT_PUBLIC_CHAT_JOIN,
	TXT_MEMBER_LIST,
	TXT_PUBLIC_CHAT_HEADER,
	TXT_MSG_CREATE_POST,
	TXT_MSG_DEL_CUR,
	TXT_MSG_REPLY_CUR,
	TXT_MSG_CLOSE_CHANNEL,
	TXT_MSG_OPEN_CHANNEL,
	TXT_MSG_CHANNEL_CLOSED,
	TXT_THIS_MSG_DELETED,
	CHAT_MSG_MIN_WORDS,
	TXT_CHAT_UPLOAD_BK,
	TXT_CHAT_CLEAR_BK,
	TXT_SHARE_CHAT,
	TXT_SHARE_CHAT_SUCCESS,
	TXT_MSG_SHAREAPOST_TAG,
	TXT_CMT_REPLY_ONLY,
	TXT_CMT_REPLY_ALL,
	TXT_NOLIKE_TITLE,
	TXT_NOLIKE_DESC,
	TXT_NOLIKE_ADS_AVAIL,
	TXT_NOLIKE_OK,
	TXT_NOLIKE_WATCH_ADS,
	TXT_NOLIKE_ADS_UNAVAIL,
	TXT_NOLIKE_WATCH_NOADS,
	TXT_CHAT_CHANGE_NAME,
	TXT_CHAT_NAME_TITLE,
	TXT_CHAT_NAME_DESC,
	TXT_CHAT_NAME_BUT,
	TXT_RANDOM_CHAT_TITLE,
	TXT_RANDOM_CHAT_DESC,
	TXT_ASK_EXIT_RCHAT_TITLE,
	TXT_ASK_EXIT_RCHAT_DESC,
	TXT_RCHAT_PROFILE_TITLE,
	TXT_RCHAT_INIT_CAP,
	TXT_RCHAT_INIT_DESC,
	TXT_RCHAT_ERR_CAP,
	TXT_RCHAT_ERR_DESC,
	TXT_RCHAT_PROFILE_CAP,
	TXT_RCHAT_PROFILE_DESC,
	TXT_RCHAT_SET_NAME,
	TXT_RCHAT_SET_AVT,
	TXT_RCHAT_SET_GENDER,
	TXT_RCHAT_SET_LOOKFOR,
	TXT_RCHAT_BOY,
	TXT_RCHAT_GIRL,
	TXT_RCHAT_BOTH,
	TXT_RCHAT_EXIT_CAP,
	TXT_RCHAT_EXIT_DESC,
	TXT_RCHAT_SEARCH_CAP,
	TXT_RCHAT_SEARCH_DESC1,
	TXT_RCHAT_SEARCH_DESC2,
	TXT_RCHAT_LEFT_CAP,
	TXT_RCHAT_LEFT_DESC,
	TXT_RCHAT_SKIP_BUT,
	TXT_RCHAT_FRIEND_BUT,
	TXT_RCHAT_REVEAL_BUT,
	TXT_RCHAT_FRIEND_REQ,
	TXT_RCHAT_EXIT,
	TXT_RCHAT_OK,
	TXT_CONTENT_ADD_ACTION,
	TXT_CONTENT_ADD_PUBLIC_CHAT,
	TXT_RCHAT_ONLINE_USERS,
	TXT_VIDEO_CONTENT_ERROR,
	TXT_VID_NOMORE_VIDEO,
	TXT_CHAT_JOIN_GROUP,
	TXT_SPONSOR_POST,
	TXT_SPONSOR_HELP_CAP,
	TXT_SPONSOR_HELP_DESC,
	TXT_SPONSOR_HELP_CLOSE,
	TXT_BOOST_POST,
	TXT_BOOST_CAP,
	TXT_BOOST_BUT,
	TXT_BOOST_BUY_NTK,
	TXT_BOOST_AMT_LBL,
	TXT_BOOST_REACH,
	TXT_INVALID_BOOST_AMT,
	TXT_BOOST_CANCEL,
	TXT_BOOST_PAUSE,
	TXT_BOOST_UNPAUSE,
	TXT_BOOST_INIT_AMT,
	TXT_BOOST_AMT_LEFT,
	TXT_BOOST_CANCEL_CAP,
	TXT_BOOST_CANCEL_DESC,
	TXT_CONTENT_MINT_SUS,
	TXT_VIDEO_SWIPE_UP,
	TXT_VIDEO_SWIPE_DOWN,
	TXT_SETUP_LOCK_CAP,
	TXT_SETUP_LOCK_LBL,
	TXT_SEND_PAYMENT_CAP,
	TXT_SEND_AMOUNT_LBL,
	TXT_DO_SEND_BUT,
	TXT_BALANCE,
	TXT_INVALID_SEND_AMT,
	TXT_MSG_SENT_MONEY_TAG,
	TXT_MSG_OPEN_WALLET,
	TXT_BOX_MARKET,
	TXT_BOX_GAMES,
	TXT_BOX_WALLET,
	TXT_MARKET_SEARCH,
	TXT_MARKET_PRICE,
	TXT_MARKET_LOCATION,
	TXT_ADD_SEL_CAT,
	TXT_ADD_SEL_CAT_INFO,
	TXT_ADD_ITEM_PRICE,
	TXT_ADD_ITEM_CURRENCY,
	TXT_ADD_AVAIL_LOCS,
	TXT_ADD_LOC_ADD,
	TXT_LOC_SELECT_TITLE,
	TXT_ADD_INVALID_CAT,
	TXT_ADD_INVALID_LOC,
	TXT_ADD_INVALID_IMG,
	TXT_MK_CATEGORIES,
	TXT_MK_SELL,
	TXT_MK_DEF_LOC,
	TXT_MK_POSTED_BY,
	TXT_MK_INTERESTED_MSG,
	TXT_MK_INTERESTED_SEND,
	TXT_MK_MSG_SENT,
	TXT_MK_AVAIL_LOC,
	TXT_MK_SELECT_CATEGORY,
	TXT_MK_SEARCH,
	TXT_MK_SEARCH_CANCEL,
	TXT_MK_EMPTY,
	TXT_GP_PAYMENT_CAP,
	TXT_GP_MAKE_PAY,
	TXT_GP_PAY_CLOSE,
	TXT_GP_PAY_SUCCESSFUL,
	TXT_GAMES_LAST_USED,
	GP_PRICE,
	TXT_GP_SHARE_CAP,
	TXT_GP_SHARE_BUT,
	TXT_GP_SHARE_CLOSE,
	TXT_WALLET_EXCHANGE,
	TXT_WALLET_BUY_LIKE,
	TXT_WALLET_TOPUP,
	TXT_WALLET_WITHDRAW,
	TXT_NTK_EX_LEFT,
	TXT_NTK_EX_CAP,
	TXT_USD_EXCHANGE_CAP,
	TXT_USD_EXCHANGE_BUT,
	TXT_USD_EX_EXCHANGE,
	TXT_USD_EX_XRATE,
	TXT_USD_EX_RECEIVE,
	TXT_NTK_LEFT,
	TXT_NTK_USD_EX_CAP,
	TXT_NTK_USD_SUS_CAP,
	TXT_ADDRESS_TITLE,
	TXT_ADDRESS_COPIED,
	TXT_ADDRESS_INFO,
	TXT_ADDRESS_SHOWHOW,
	TXT_ADD_TIMELEFT,
	TXT_ADDRESS_DOCOPY,
	TXT_ADD_TIME_INFO_1,
	TXT_ADD_TIME_INFO_2,
	TXT_WIDTHDRAW_INVALD_ADD,
	TXT_WIDTHDRAW_INVALID_AMT,
	TXT_WIDTHDRAW_TITLE,
	TXT_WIDTHDRAW_INFO,
	TXT_WIDTHDRAW_LBL,
	TXT_WIDTHDRAW_USDT,
	TXT_WIDTHDRAW_DO,
	TXT_WIDTHDRAW_HOW,
	TXT_QUICK_WITHDRAW,
	TXT_QUICKW_CAP,
	TXT_QUICKW_EDIT_ADD,
	TXT_QUICKW_LBL,
	TXT_QUICKW_BUT,
	TXT_LAST_WITHDRAW_ADD,
	TXT_WITHDRAW_ADD_SEEMORE,
	TXT_WIDTHDRAW_SUS,
	TXT_WIDTHDRAW_ADDRESS,
	TXT_WIDTHDRAW_AMT,
	TXT_WIDTHDRAW_BACK,
	TXT_WIDTHDRAW_TIME,
	TXT_WITHDRAW_ADDRESS,
	TXT_SENDCON_TITLE,
	TXT_SENDCON_SENDTO,
	TXT_SENDCON_AMT,
	TXT_SENDCON_FEE,
	TXT_SENDCON_LEFT,
	TXT_SENDCON_DO,
	TXT_WALLET_PASSKEY_CAP,
	TXT_WALLET_PASSKEY_DESC,
	TXT_WALLET_PASSKEY_DO,
	TXT_EDIT_POST_CAP,
	TXT_EDIT_POST_TITLE,
	TXT_EDIT_POST_DESC,
	TXT_EDIT_POST_DO,
	TXT_EDIT_POST,
	TXT_REPORT_COPYRIGHT,
	TXT_REPORT_COPYRIGHT_URL,
	TXT_COPYRIGHT_URL,
	TXT_EXPLAIN_COPYRIGHT,
	TXT_BOOST_REPORT,
	TXT_NOLIKE_BUY,
	TXT_NOLIKE_BUY_DESC,
	TXT_NOLIKE_GAME,
	TXT_NOLIKE_GAME_DESC,
	TXT_BOOST_REPORT_CAP,
	TXT_NO_BOOST_DATA,
	TXT_ALREADY_LOGIN,
	TXT_NEED_LOGIN,
	TXT_USER_SHARE
};

// retrieve the text
export const GetStr = (index : number) : string => {
	if (lang_selected == "")
		lang_selected = window.localStorage["lang"];

	let lang = mmun_texts;
	if (lang_selected == "en")
		lang = en_texts;
	if (lang_selected == "mand")
		lang = mand_texts;
	/* DEL
	if (lang_selected == "sha")
		lang = sha_texts;
	if (lang_selected == "kch")
		lang = kch_texts;
	if (lang_selected == "chin")
		lang = chin_texts;
	*/
	return lang[index]!;
};

// retrieve the text
export const GetLangStr = (index : number, lang_name : string) => {
	let lang = mmun_texts;
	if (lang_name == "en")
		lang = en_texts;
	if (lang_name == "mand")
		lang = mand_texts;
	/* DEL
	if (lang_name == "sha")
		lang = sha_texts;
	if (lang_name == "kch")
		lang = kch_texts;
	if (lang_name == "chin")
		lang = chin_texts;
	*/
	return lang[index];
};



// load the saved language info
export const LoadLanguage = async () => {
	const lang = await Storage.get({ key: 'lang' });
	const lang_val = lang.value as string;

	if (lang_val != null)
	{
		lang_selected = lang_val;
		window.localStorage["lang"] = lang_val;
	}
};

// retrievet the current language
export const SaveLanguage = async (lang : string) => {
	await Storage.set({
        key: 'lang',
        value: lang,
    });
	lang_selected = lang;
	window.localStorage["lang"] = lang;
};

// retrieve the current language
export const GetLanguage = () : string => {
	return lang_selected;
};